<template>
  <div class="UserAttributesInteractiveForm">
    <InteractiveForm
      ref="rfUserAttrForm"
      :auto-selectable-steps="steps"
      :busy="busy"
      current-form="user-attributes"
      :steps="steps"
      @submit="submit"
    >
      <template #default="{ step }">
        <!-- CPF -->
        <!-- tem carro -->
        <YesOrNoCheckInput
          v-if="displayInput(step, 'has_auto')"
          id="has_auto"
          key="has_auto"
          v-model="userAttributes.has_auto"
          name="has_auto"
          label="Você possui veículo em seu nome, em nome de cônjuge ou de parente de 1º grau?"
          helper-message="É considerado parente de 1º grau, pais, irmãos e filhos."
          :validation="true"
          @input="autoSelectField('has_auto', $event)"
        />
        <!-- tem casa -->
        <YesOrNoCheckInput
          v-if="displayInput(step, 'has_property')"
          id="has_property"
          key="has_property"
          v-model="userAttributes.has_property"
          label="Você possui imóvel em seu nome?"
          name="has_property"
          :validation="true"
          @input="autoSelectField('has_property', $event)"
        />
      </template>
    </InteractiveForm>
  </div>
</template>
<script>
import { nextTick } from 'vue'
import YesOrNoCheckInput from '@/components/forms/fields/checkInput/YesOrNoCheckInput.vue'
import InteractiveForm from '@/components/forms/InteractiveForm.vue'
export default {
  name: 'UserAttributesInteractiveForm',
  components: {
    YesOrNoCheckInput,
    InteractiveForm,
  },
  props: {
    busy: { type: Boolean, default: false },
  },
  emits: ['submit'],
  data() {
    return {
      userAttributes: {
        has_property: '',
        has_auto: '',
      },
      steps: ['has_property', 'has_auto'],
    }
  },
  methods: {
    autoSelectField(key, value) {
      this.userAttributes[key] = value
      nextTick(() => {
        this.$refs.rfUserAttrForm.next()
      })
    },
    displayInput(step, key) {
      return step === key
    },
    submit() {
      this.$emit('submit', this.userAttributes)
    },
  },
}
</script>
<style lang="scss">
.UserAttributesInteractiveForm {
  .auto-suggest-wrapper {
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: $color-neutral-light;
    border-radius: 12px;
    padding: 16px;

    .description {
      @include body-2;
      color: $color-black-high;
      margin: 0 0 16px 0;
      text-align: center;
    }

    .Button {
      width: 100%;
      max-width: 296px;
      background-color: transparent;
      margin-bottom: 8px;

      &:last-child {
        margin: 0;
      }
    }
  }
}
</style>
